import React, { FunctionComponent } from 'react';
import { closex } from '../icon';

export interface ITopBarProps {
  hide: () => void;
  children: JSX.Element;
  theme?: 'WHITE' | 'BLACK';
}

export const TopBar: FunctionComponent<ITopBarProps> = ({ hide, children, theme }) => {
  return (
    <div className={`h-20 ${theme === 'BLACK' ? 'bg-neutral-matte-black' : 'bg-primary-white'} shadow-md sticky z-50 top-0`}>
      <div className="container m-auto flex justify-between items-center h-full px-12 md:px-0">
        <button className="text-heading-mobile-l rounded-full md:w-11 md:h-11 w-8 h-8 text-primary-white  bg-primary-bright-blue" onClick={hide}>
          {closex}
        </button>
        <div className="flex-1">
          {children}
          <div className="w-8"></div>
        </div>
      </div>
    </div>
  );
};
